export default __webpack_public_path__ + "static/media/Group502.0661ebac.png";